const listBreadcrumb = {
  text: 'route.list',
  to: 'list',
  link: true
}

const relationBreadcrumbKey = 'kodeverkTable.title.relations'
const relationBaseBreadcrumb = [
  listBreadcrumb,
  {
    text: relationBreadcrumbKey,
    to: 'relations',
    link: true
  }
]

export default [
  {
    path: '/relations',
    name: 'RelationList',
    component: () => import('@/views/relations/RelationsListView.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: relationBreadcrumbKey,
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/exam-assessment-pupil',
    name: 'ExamAssessmentPupil',
    component: () => import('@/views/relations/ExamAssessmentPupilView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.examAssessmentPupil',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/exam-assessment-private',
    name: 'examAssessmentPrivate',
    component: () => import('@/views/relations/ExamAssessmentPupilView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.examAssessmentPrivate',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/element-replaces-element',
    name: 'elementReplacesElement',
    component: () => import('@/views/relations/CourseCourseView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.elementReplacesElement',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/course-paabygning',
    name: 'coursePaabygning',
    component: () => import('@/views/relations/CourseCourseView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.coursePaabygning',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/course-belongs-to-programarea',
    name: 'courseBelongsToProgramarea',
    component: () => import('@/views/relations/CourseProgramAreaView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.courseBelongsToProgramarea',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/main-course-sub-course',
    name: 'mainCourseSubCourse',
    component: () => import('@/views/relations/CourseCourseView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.mainCourseSubCourse',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/main-areas',
    name: 'mainAreasRelation',
    component: () => import('@/views/relations/CurriculumMainAreaView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.mainAreas',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/main-area-relates-to-competence-set',
    name: 'mainAreaRelatesToCompetenceSet',
    component: () => import('@/views/relations/MainAreaCompetenceSetView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.mainAreaRelatesToCompetenceSet',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/fam-connected-to-course',
    name: 'famConnectedToCourse',
    component: () => import('@/views/relations/CourseRemarkCourseView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.famConnectedToCourse',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/competence-set-after-courses',
    name: 'competenceSetAfterCourses',
    component: () => import('@/views/relations/CompetenceSetCourseView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.competenceSetAfterCourses',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/competence-set-after-curriculum',
    name: 'competenceSetAfterCurriculum',
    component: () => import('@/views/relations/CurriculumCompetenceSetView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.competenceSetAfterCurriculum',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/competence-set-has-competence-goal',
    name: 'competenceSetHasCompetenceGoal',
    component: () => import('@/views/relations/CompetenceSetCompetenceView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.competenceSetHasCompetenceGoal',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/programarea-paabygning',
    name: 'programareaPaabygning',
    component: () => import('@/views/relations/ProgramAreaProgramAreaView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.programareaPaabygning',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/programarea-belongs-to-curriculum',
    name: 'programareaBelongsToCurriculum',
    component: () => import('@/views/relations/CurriculumProgramAreaView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.programareaBelongsToCurriculum',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/programarea-belongs-to-educationprogram',
    name: 'programareaBelongsToEducationprogram',
    component: () => import('@/views/relations/EducationProgramProgramAreaView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.programareaBelongsToEducationprogram',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/belongs-to-mainarea',
    name: 'belongsToMainarea',
    component: () => import('@/views/relations/MainAreaCompetenceView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.belongsToMainarea',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/used-in-yearlevel',
    name: 'usedInYearLevel',
    component: () => import('@/views/relations/UsedInYearLevelView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.usedInYearLevel',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/builds-on',
    name: 'buildsOn',
    component: () => import('@/views/relations/BuildsOnView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.buildsOn',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/replaced-by',
    name: 'replacedBy',
    component: () => import('@/views/relations/ReplacedByView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.replacedBy',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/after-yearlevel',
    name: 'afterYearLevel',
    component: () => import('@/views/relations/AfterYearLevelView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.afterYearLevel',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/after-course',
    name: 'afterCourse',
    component: () => import('@/views/relations/AfterCourseView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.afterCourse',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/course-used-together-with',
    name: 'courseUsedTogetherWith',
    component: () => import('@/views/relations/CourseUsedTogetherWithView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.courseUsedTogetherWith',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/coursetype',
    name: 'coursetype',
    component: () => import('@/views/relations/CourseTypeView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.coursetype',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/coursetype-educationlevel',
    name: 'coursetypeEducationLevel',
    component: () => import('@/views/relations/CourseTypeEducationLevelView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.coursetypeEducationlevel',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/has-competence-goal',
    name: 'hasCompetenceGoal',
    component: () => import('@/views/relations/HasCompetenceGoalView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.hasCompetenceGoal',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/competenceset-connected-curriculum',
    name: 'competenceSetConnectedToCurriculum',
    component: () => import('@/views/relations/CompetenceGoalConnectedCurriculumView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.competenceSetConnectedToCurriculum',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/label-related-curriculum',
    name: 'labelRelatedToCurriculum',
    component: () => import('@/views/relations/LabelRelatedToCurriculumView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.labelRelatedToCurriculum',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/label-related-programarea',
    name: 'labelRelatedToProgramarea',
    component: () => import('@/views/relations/LabelRelatedToProgramareaView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.labelRelatedToProgramarea',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/connected-to-general-skill',
    name: 'connectedToGeneralSkill',
    component: () => import('@/views/relations/ConnectedToGeneralSkillView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.connectedToGeneralSkill',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/connected-to-core-element',
    name: 'connectedToCoreElement',
    component: () => import('@/views/relations/ConnectedToCoreElementView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.connectedToCoreElement',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/connected-to-interdisciplinary-subject',
    name: 'connectedToInterdisciplinarySubject',
    component: () => import('@/views/relations/ConnectedToInterdisciplinarySubectView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.connectedToInterdisciplinarySubject',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/connected-to-verb',
    name: 'connectedToVerb',
    component: () => import('@/views/relations/ConnectedToVerbView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.connectedToVerb',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/relation/verb-belongs-to-curriculum',
    name: 'verbBelongsToCurriculum',
    component: () => import('@/views/relations/VerbBelongsToCurriculumView.vue'),
    meta: {
      breadcrumbs: [
        ...relationBaseBreadcrumb,
        {
          text: 'kodeverkTable.title.relation.verbBelongsToCurriculum',
          disabled: true
        }
      ]
    }
  }
]
